<template>
  <p
    class="form-helper"
    :class="brandClasses.variant?.[activeVariant]?.wrapper"
  >
    <slot />
  </p>
</template>

<script lang="ts" setup>
const props = defineProps<{
  /**
   * Defines variant
   */
  variant?: 'inverse'
}>()

const { brandClasses } = useAppConfig().components.form.hint
const activeVariant = computed(() => props.variant || 'base' as const)
</script>
